import { useQuery, useMutation, gql } from '@apollo/client';
import {
  NOTIFICATIONS_LIST,
  NOTIFICATION_GET,
  NOTIFICATION_CREATE,
  NOTIFICATION_UPDATE_STATUS,
  NOTIFICATION_CLEAR,
  NOTIFICATION_TEMPLATES_LIST,
  UNREAD_NOTIFICATIONS_COUNT,
  NOTIFICATIONS_GROUPED_BY_STATUS
} from '../graphql/notifications';

// Custom hooks for notifications
export const useNotifications = (filters = {}) => {
  return useQuery(NOTIFICATIONS_LIST, {
    variables: { 
      filter: filters,
      orderBy: ["createdAt_DESC"]
    },
    fetchPolicy: 'cache-and-network'
  });
};

export const useUnreadCount = (userId) => {
  return useQuery(UNREAD_NOTIFICATIONS_COUNT, {
    variables: {
      filter: {
        userId: { id: { equals: userId } },
        status: { equals: "UNREAD" }
      }
    },
    fetchPolicy: 'cache-and-network'
  });
};

// Optimized hook to get notifications grouped by status with counts
export const useNotificationsGroupedByStatus = (userId) => {
  return useQuery(NOTIFICATIONS_GROUPED_BY_STATUS, {
    variables: { userId },
    fetchPolicy: 'cache-and-network',
    skip: !userId
  });
};

export const useCreateNotification = () => {
  return useMutation(NOTIFICATION_CREATE, {
    // Don't refetch queries to avoid loading spinner
    // The real-time subscription will handle UI updates
    refetchQueries: false,
    // Comment out the old approach that caused loading spinner
    // refetchQueries: [NOTIFICATIONS_LIST, UNREAD_NOTIFICATIONS_COUNT],
    onCompleted: (data) => {
      // Handle the new response structure
      if (data.createNotification.success) {
        console.log('✅ Notification created successfully:', data.createNotification.notificationId);
      } else {
        console.error('❌ Notification creation failed:', data.createNotification.errors);
        // You can add toast notifications here if needed
        data.createNotification.errors.forEach(error => {
          console.error('Error:', error);
        });
      }
    },
    onError: (error) => {
      console.error('❌ GraphQL mutation error:', error);
    }
  });
};

export const useUpdateNotificationStatus = () => {
  return useMutation(NOTIFICATION_UPDATE_STATUS, {
    update: (cache, { data }) => {
      // Refetch unread count after status update
      cache.evict({ fieldName: 'notificationsList' });
      cache.gc();
    }
  });
};

export const useClearNotification = () => {
  return useMutation(NOTIFICATION_CLEAR);
};

export const useNotificationTemplates = () => {
  return useQuery(NOTIFICATION_TEMPLATES_LIST);
};

// For template-based notifications (custom function)
export const useCreateNotificationFromTemplate = () => {
  return useMutation(gql`
    mutation CreateNotificationFromTemplate($data: JSON!) {
      createNotification(data: $data) {
        success
        notificationId
        error
      }
    }
  `);
};